import type { ReactNode } from 'react';
import { cn } from '../cn.js';

/**
 * Stato vuoto: una sola azione, nessun muro di testo.
 * Il tono e' quello di un amico organizzato, non di un messaggio di errore.
 */

export interface EmptyStateProps {
  readonly icon?: ReactNode;
  readonly title: string;
  readonly description?: string;
  readonly action?: ReactNode;
  readonly className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps): ReactNode {
  return (
    <div className={cn('flex flex-col items-center gap-3 px-6 py-12 text-center', className)}>
      {icon !== undefined && icon !== null ? (
        <span aria-hidden="true" className="text-brand opacity-80">
          {icon}
        </span>
      ) : null}
      <h2 className="font-display text-[20px] leading-7 text-text">{title}</h2>
      {description !== undefined ? (
        <p className="max-w-[38ch] text-[15px] leading-6 text-text-muted">{description}</p>
      ) : null}
      {action !== undefined && action !== null ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
